<div class="ligne_form row marges">
    <div class="col_12">
        <div class="form-group">
            <app-core-select-search [configuration]="searchConfiguration" [sourceCallback]="searchSourceCallback" [formGroupReference]="offerLocationTransportControl" [formControlNameReference]="'transport'"></app-core-select-search>
        </div>
    </div>
</div>
